import { jsPDF } from "jspdf"
import 'jspdf-autotable'
import ExcelJs from 'exceljs'
import * as FileSaver from 'file-saver'

export function exportCsv(data, filename = 'Export_Files_Records.csv') {
    const content = data.map(v => {
        return v.map(vv => {
            return vv.replace(new RegExp(',', 'g'), '，').replace("\n", '').replace("\r", '')
        }).join(', \t')
    }).join('\n')
    const uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(content)
    const link = document.createElement('a')
    link.href = uri
    link.download = filename
    link.click()
}

export function exportPdf(data, filename = 'export_by_kcc.pdf') {
    jsPDF.API.events.push(['addFonts', callAddFont])
    
    // 初始化jspdf 第一个参数方向：默认''时为纵向，第二个参数设置pdf内容图片使用的长度单位为pt，第三个参数为PDF的大小，单位是pt
    var pdf = new jsPDF('', 'pt')

    // 修改字体，支持中文
    pdf.setFont('Deng')

    // 最大的标题
    pdf.setFontSize(50).text(filename.replace('.pdf', ''), 20, 350)

    // 翻页
    pdf.addPage()

    const imgW = data.level12.w
    const imgH = data.level12.h
    pdf.addImage(
        data.level12.base64,
        'jpeg',
        20, 150,
        imgW < 595 ? imgW : 595,
        imgW < 595 ? imgH : 595 / imgW * imgH
    )

    data.level3.forEach((v, k) => {
        pdf.addPage()
        pdf.autoTable({
            styles: {fillColor: [243, 247, 255], font: 'Deng', textColor: [0, 0, 0] , halign: 'center'},
            theme: 'grid',           // 主题
            startY: 100,          // 距离上边距离
            body: data.level3[k].map((vv, kk) => ({
                data_0: vv.target,
                data_1: data.valueType == 'value' ? vv.value21 : (!vv.percent21 ? 0 : `${vv.percent21} %`),
                data_2: data.valueType == 'value' ? vv.value22 : (!vv.percent22 ? 0 : `${vv.percent22} %`),
                data_3: vv.value23,
                data_4: data.valueType == 'value' ? vv.value24 : (!vv.percent24 ? 0 : `${vv.percent24} %`),
            })),        // tableDate
            columns: data.level3Th[k].map((vv, kk) => ({
                title: vv,
                dataKey: `data_${kk}`
            }))
        })
    })
    

    pdf.save(filename, pdf)
}

export function exportFileLogXls(data, filename = 'Export_Files_Records.xlsx') {
    // 创建工作簿
    const workbook = new ExcelJs.Workbook();
    // 添加sheet
    const worksheet = workbook.addWorksheet('Demo');
    // 设置 sheet 的默认行高
    worksheet.properties.defaultRowHeight = 20;
    // 添加行
    worksheet.addRows(data);
    // 给表头添加背景色
    let headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
        cell.font = {
            color: { argb: 'FFFFFFFF' },
        }
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'FF003366'},
        }
    })

    workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });    
        FileSaver.saveAs(blob, filename);
    })
}